'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = install;

var _formatters = require('./formatters');

var _formatters2 = _interopRequireDefault(_formatters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// optional global check
if (typeof mobx !== 'undefined') {
  mobx.installDevTools = install.bind(null, mobx);
}

var installed = false;

function install(mobx) {
  if (typeof window === 'undefined') {
    throw new Error('Can only install mobx-devtools in a browser environment.');
  }

  // Don't install more than once.
  if (installed === true) {
    return;
  }

  window.devtoolsFormatters = window.devtoolsFormatters || [];

  var _mobxFormatters = (0, _formatters2.default)(mobx),
      ArrayFormatter = _mobxFormatters.ArrayFormatter,
      ObjectFormatter = _mobxFormatters.ObjectFormatter;

  window.devtoolsFormatters.push(ArrayFormatter, ObjectFormatter);

  installed = true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-formatters/lib/index.js
// module id = 557
// module chunks = 26